import Model from './Model';
import { isOnline } from '@helpers';
import Storage from '@services/Storage';
import { StoreNames } from '@app/Constants/storage';

export default class extends Model {
  static data() {
    return {
      id: '',
      name: '',
      latin_name: '',
      has_custom_cost: false,
      recommended_cost: '',
      cost: '',
      family_id: '',
    };
  }

  async findById(id) {
    let url = `/species/${id}?` + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-species'
      )
    );
  }

  async get() {
    if (isOnline() && !this.fetchOffline) {
      let url = '/species?' + this.getParamsAsQueryParam();
      return this.getPromise(url).catch((error) =>
        $showError(
          error.response.data.message || 'something went wrong!',
          'fetch-species'
        )
      );
    }
    return await this.getFromLocalStorage();
  }

  async getFromLocalStorage() {
    const storage = new Storage();
    const pagination = this.getPagination();
    const species = await storage.find(StoreNames.SPECIES, {
      limit: pagination.rowePerPage,
      searchTerm: pagination.filters.name || '',
      searchSubject: 'name',
      excludeIds: pagination.filters.excludes || '',
      includeIds: pagination.filters.include_ids || '',
      sortBy: 'created_at',
      sortOrder: 'asc',
    });

    return new Promise((resolve) => {
      resolve({
        data: species || [],
      });
    }).finally(() => {
      this.fetched = true;
    });
  }

  async save(project) {
    if (project.id) {
      let url = `/species/${project.id}`;
      return this.patchPromise(url, project);
    }
    return this.postPromise(`species`, project);
  }

  async delete(id) {
    let url = `/species/${id}`;
    return this.deletePromise(url).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'delete-project'
      )
    );
  }

  async fetchStats(id) {
    let url = `species/${id}/statistics?` + this.getParamsAsQueryParam();
    return this.getPromise(url).catch((error) => {
      $showError(
        error.response.data.message || 'something went wrong!',
        'fetch-species-statistics'
      );
    });
  }

  async updateCustomPrice(id, cost) {
    let url = `species/${id}/prices`;
    return this.putPromise(url, { cost }).catch((error) =>
      $showError(
        error.response.data.message || 'something went wrong!',
        'set-custom-price-species'
      )
    );
  }
}
